import {
  Component,
  ElementRef,
  inject,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { first } from "rxjs";
import { Admin } from "../../services/admin";
import { Auth } from "../../services/auth";
import { Country, State, City } from "country-state-city";
import { MatDialog } from "@angular/material/dialog";
import { MyDrive } from "../my-drive/my-drive";
import { User } from "../../services/user";
import { MatSnackBar } from '@angular/material/snack-bar';
import { SuccessDialog } from "../../pages/common-features/success-dialog/success-dialog";
import { TitleCasePipe } from "@angular/common";
import { ViewUploadedFile } from "../../pages/common-features/view-uploaded-file/view-uploaded-file";
@Component({
  selector: "app-profile",
  standalone: false,
  templateUrl: "./profile.html",
  styleUrl: "./profile.less",
})
export class Profile implements OnInit {
  private authService = inject(Auth);
  private adminService = inject(Admin);
  private formBuilder = inject(FormBuilder);
  private matDialog = inject(MatDialog);
  private router = inject(Router);
  private userService = inject(User);
  selectedFiles: any;
  loading: boolean = false;
  selectedField: string | null = null;
  uploadedFiles: any[] = [];
  @ViewChild("fileInput") fileInput!: ElementRef<HTMLInputElement>;
  typeOfCompanyList: string[] = [
    "Pvt Ltd",
    "Patnership",
    "Proprietiership",
    "Limited",
  ];
  intercoms: string[] = ["FOB", "DDP", "CIF", "Ex-Works"];
  user: any;
  imgData: any;
  profileForm!: FormGroup;
  countries = Country.getAllCountries();
  progress: any;
  error: any;
  message: any;
  org: any;
  uploadedFileId: any;
  panCardUploadId: any;
  gstUploadId: any;
  iecUploadId: any;
  fssaiUploadId: any;
  certificateOfIncorporationUploadId: any;
  aadharCardUploadId: any;
  bankAccountUploadId: any;
  udhyamCertificateUploadId: any;
  businessCertificateUploadId: any;
  showProfileOptions: boolean = false;
  showDocTypeError: boolean = false;
  docSelection: any;
  uploadDocuments: any[] = [
    {
      label: "Select",
      value: "",
    },
    {
      label: "Personal KYC",
      value: "personalKYC",
    },
    {
      label: "Food License",
      value: "foodLicense",
    },
    {
      label: "Import Export Certificate",
      value: "importExportCertificate",
    },
    {
      label: "Bank Details/Letter",
      value: "bankDetailsOrLetter",
    },
    {
      label: "Business Address Proof",
      value: "businessAddressProof",
    },
    // {
    //   label: "Bank Details",
    //   value: "bankAccountNumber",
    // },
    // {
    //   label: "Aadhar Card",
    //   value: "aadharCard",
    // },
    // {
    //   label: "Udhyam Certificate",
    //   value: "udyamCertificate",
    // },
    // {
    //   label: "PAN",
    //   value: "pan",
    // },
  ];
  private snackBar = inject(MatSnackBar);
  private titleCase = inject(TitleCasePipe);
  constructor() {
    this.authService.user.subscribe((x: any) => (this.user = x));
    this.authService.imgData$.subscribe((img: any) => (this.imgData = img));
    this.profileForm = this.formBuilder.group({
      firstName: [""],
      lastName: [""],
      companyName: [""],
      mobilePhone: [""],
      aadharCardNumber: [""],
      country: [""],
      emailId: [""],
      userType:[""],
      patnerName: [""],
      directorOrPatner: [""],
      typeOfCompany: [""],
      officeAddress: [""],
      officeContactNumber: [""],
      officeEmailId: [""],
      gst: [""],
      pan: [""],
      iec: [""],
      fssai: [""],
      certificateOfIncorporation: [""],
      patnerKyc: [""],
      bankAccountNumber: [""],
      bankIfscCode: [""],
      bankBranchAddress: [""],
      adCode: [""],
      icegate: [""],
      dscCheck: [""],
      lmpc: [""],
      phytoLogin: [""],
      eprCertificate: [""],
      udyam: [""],
      businessCertificate: [""],
      partnerName: [""],
      intercoms: [""],
    });
  }

  ngOnInit(): void {
    this.authService.imgData$.subscribe((img: any) => (this.imgData = img));
    console.log(this.imgData);
    this.getOrg();
  }

  patchProfileForm() {
    this.profileForm.patchValue({
    firstName: this.user.firstName,
    lastName: this.user.lastName,
    emailId: this.user.emailId,
    mobilePhone: this.user.mobilePhone,
    country: this.transform(this.user.country),
    userType:this.titleCase.transform(this.user.userType).split('_')[0],
    officeAddress: this.org.addLine1,
    officeEmailId: this.user.emailId,
    officeContactNumber: this.user.mobilePhone,
    companyName: this.org.name,
    businessCertificate: this.user?.userDetail?.businessCertificate
      ? this.user.userDetail.businessCertificate
      : "",
    bankAccountNumber: this.applyInitialFormatting(this.user?.userDetail?.bankAccountNumber),
    bankIfscCode: this.user?.userDetail?.bankIfscCode
      ? this.user.userDetail.bankIfscCode
      : "",
    bankBranchAddress: this.user?.userDetail?.bankBranchAddress
      ? this.user.userDetail.bankBranchAddress
      : "",
  });
  }

applyInitialFormatting(value: string): string {
  if (!value) return '';
  let cleaned = value.replace(/\D/g, '');
  let formatted = '';
  for (let i = 0; i < cleaned.length; i++) {
    if (i > 0 && i % 4 === 0) {
      formatted += ' ';
    }
    formatted += cleaned[i];
  }
  return formatted;
}

    //  if(this.user.userDetail){
    //     console.log(this.user.userDetail);
    //   this.profileForm.patchValue(this.user.userDetail);// this is not working
    //  }
  

transform(value: string): string {
  if (!value) return "";
  return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
}

triggerFileInput(fieldName ?: any): void {
  if(fieldName && fieldName !== '') {
  this.selectedField = fieldName;
  this.showDocTypeError = false;
  this.fileInput.nativeElement.click();
} else {
  this.showDocTypeError = true;
  // this.showAlert('Please select a file category before uploading');
}
  }

showAlert(message: string) {
  this.snackBar.open(message, '', {
    duration: 3000,
    verticalPosition: 'bottom',
    horizontalPosition: 'center',
    panelClass: 'wa-banner'
  });

}

handleFileSelect(event: any) {
  this.selectedFiles = event.target.files;
  const inputElement = this.fileInput.nativeElement;
  if (this.selectedFiles) {
    this.uploadMedia(this.selectedFiles, this.selectedField);
    // if(this.selectedField == 'profilePic'){
    //   this.uploadProfilePic(this.selectedFiles,'profilePic');
    // }
  }
  this.showProfileOptions = false;
}

onDragOver(event: any) {
  event.preventDefault();
  event.stopPropagation();
  event.currentTarget.classList.add('drag-over');
}

onDragLeave(event: any) {
  event.preventDefault();
  event.stopPropagation();
  event.currentTarget.classList.remove('drag-over');
}

onDrop(event: any) {
  event.preventDefault();
  event.stopPropagation();
  event.currentTarget.classList.remove('drag-over');

  if (!this.selectedField || this.selectedField === '') {
    this.showDocTypeError = true;
    // this.showAlert('Please select a file category before uploading');
    return;
  }

  const files = event.dataTransfer.files;
  if (files && files.length > 0) {
    this.uploadMedia(files, this.selectedField);
  }
}

toggleProfileOptions() {
  this.showProfileOptions = !this.showProfileOptions;
}

removeProfilePic() {
  this.imgData = null;
  this.updateUser("", "profilePic");
  this.showProfileOptions = false;
}

getOrg() {
  this.userService.getOrg().subscribe({
    next: (data: any) => {
      // console.log(data);
      this.org = data;
      this.patchProfileForm();
    },
    error: (error: any) => {
      console.log(error);
    },
  });
}

uploadMedia(media: any, docType: any) {
  if (!media || media.length === 0) return;
  const currentFile = media.item(0);
  if (!currentFile) return;

  // 1. Max Size check (10MB)
  const maxSize = 10 * 1024 * 1024; // 10MB
  if (currentFile.size > maxSize) {
    this.messageDialog('File Too Large', 'The selected file exceeds the maximum allowed size of 10MB.', 'error');
    return;
  }

  // 2. File Type check (Images, PDF, Word Docs)
  const allowedTypes = [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'text/plain'
  ];
  const isImage = currentFile.type.startsWith('image/');
  const isAllowedType = allowedTypes.includes(currentFile.type) || isImage;
  if (!isAllowedType) {
    this.messageDialog('Invalid File Type', 'Only images, PDFs, or Word documents (.doc, .docx) are allowed.', 'error');
    return;
  }

  this.loading = true;
  const mediaData = new FormData();
  mediaData.append("file", currentFile);
  mediaData.append("entityType", 'USER');
  mediaData.append("entityId", this.user.id);
  mediaData.append("docType", docType);
  this.adminService
    .uploadProfilePic(mediaData)
    .pipe()
    .subscribe({
      next: (data: any) => {
        console.log(data);
        this.uploadedFileId = data.id;
        console.log(this.uploadedFileId);
        this.loading = false;
        this.getMediaFiles();
        this.updateUser(this.uploadedFileId, docType);
        // this.updateOrg(this.uploadedFileId, this.selectedField);
      },
      error: (error) => {
        this.loading = false;
        this.message = undefined;
        console.log(error);
      },
    });

  this.selectedFiles = undefined;
}

onSubmit() {
  this.updateUser("", "");
  // this.updateOrg('','');
}
isPrivileged(privilege: string[]) {
  const privileges: any[] = this.user.privileges;
  var check = privileges.some((x: any) => privilege.includes(x));
  return check;
}

updateUser(fileId: any, field: any) {
  this.loading = true;
  // console.log(fileId);
  // console.log(field);
  const user = {
    id: this.user.id,
    firstName: this.profileForm.value.firstName,
    lastName: this.profileForm.value.lastName,
    emailId: this.profileForm.value.emailId,
    mobilePhone: this.profileForm.value.mobilePhone,
    country: this.user.country,
    photoPath: field == "profilePic" ? fileId : this.user.photoPath,
    aadharCardNumber:
      field == "aadharCard" ? fileId : this.user.aadharCardNumber,
    inactive: this.user.inactive,
  };
  console.log(user);
  this.authService
    .updateProfile(user)
    .pipe(first())
    .subscribe({
      next: (data: any) => {
        // console.log(data);
        this.profileForm.patchValue(data);
        this.updateOrg(data);
        this.authService.getProfile(data.photoPath);
        this.imgData = data.photoPath ? this.imgData : null;
        //this.updateUserDetails(fileId,field);

        if (!this.user.userDetail || this.user.userDetail == null) {
          this.createUserDetails();
        } else {
          this.updateUserDetails(fileId, field);
        }
      },
      error: (error: any) => {
        console.log(error.error.error);
      },
    });
}

updateOrg(data ?: any) {
  // console.log(data);
  this.loading = true;
  const org = {

    id: this.user.orgId,
    addLine1: this.profileForm.value.officeAddress,
    name: this.profileForm.value.companyName,
    companyId: this.org.companyId,
    city: this.org.city,
    state: this.org.state,
    country: this.org.country,
    zipcode: this.org.zipcode,
    global: this.org.global,

    user: data
  };

  this.userService
    .updateOrg(org)
    .pipe(first())
    .subscribe({
      next: (data: any) => {
        // console.log(data.user);
        this.loading = false;
        // if (!this.user.userDetail || this.user.userDetail == null) {
        //   this.createUserDetails();
        // } else {
        //   this.updateUserDetails(fileId, field);
        // }
        //  this.authService.updateAppUser(data.user);
        //  this.profileForm.patchValue({
        //     companyName:data.name,
        //     officeAddress:data.addLine1
        //  })

        // this.updateUserDetails(fileId,field);
        // if(!this.user.userDetail || this.user.userDetail == null){
        //   this.createUserDetails();
        // }else{
        //   this.updateUserDetails(fileId,field);
        // }
      },
      error: (error: any) => {
        console.log(error.error.error);
        this.loading = false;
      },
    });
}

updateUserDetails(fieldId: any, field: any) {
  // console.log(fieldId);
  // console.log(field);
  const userDetails = {
    id: this.user.id,
    orgId: this.user.orgId,
    gst: field == "gst" ? fieldId : this.profileForm.value.gst,
    iec: this.profileForm.value.iec,
    fssai: this.profileForm.value.fssai,
    certificateOfIncorporation:
      field == "certificateOfIncorporation"
        ? fieldId
        : this.profileForm.value.certificateOfIncorporation,
    patnerKyc:
      field == "patnerKyc" ? fieldId : this.profileForm.value.patnerKyc,
    bankAccountNumber:
      field == "bankAccountNumber"
        ? fieldId
        : this.profileForm.value.bankAccountNumber,
    bankIfscCode: this.profileForm.value.bankIfscCode,
    bankBranchAddress: this.profileForm.value.bankBranchAddress,
    adCode: this.profileForm.value.adCode,
    icegate: this.profileForm.value.icegate,
    dscCheck: this.profileForm.value.dscCheck,
    lmpc: this.profileForm.value.lmpc,
    phytoLogin: this.profileForm.value.phytoLogin,
    eprCertificate: this.profileForm.value.eprCertificate,
    udyam: this.profileForm.value.udyam,
    businessCertificate: this.profileForm.value.businessCertificate,
    partnerName: this.profileForm.value.patnerName,
    intercoms: this.profileForm.value.intercoms,
    updatedBy: this.user.id,
    userId: this.user.id,
  };
  console.log(userDetails);
  this.adminService
    .updateUserDetails(userDetails)
    .pipe(first())
    .subscribe({
      next: (data: any) => {
        // console.log(data);
        this.profileForm.patchValue(data);
        this.loading = false;
        this.getUserById();
        this.messageDialog('Profile Successfully Saved!', 'Your profile details have been updated successfully.', 'success');
      },
      error: (error: any) => {
        console.log(error);
        this.loading = false;
      },
    });
}

createUserDetails() {
  const userDetails = {
    id: this.user.id,
    orgId: this.user.orgId,
    gst: "",
    iec: "",
    fssai: "",
    certificateOfIncorporation: "",
    patnerKyc: "",
    bankAccountNumber: "",
    bankIfscCode: "",
    bankBranchAddress: "",
    adCode: "",
    icegate: "string",
    dscCheck: "string",
    lmpc: "string",
    phytoLogin: true,
    eprCertificate: "string",
    udyam: "string",
    businessCertificate: "string",
    partnerName: this.profileForm.value.patnerName,
    intercoms: "string",
    createdBy: "string",
    updatedBy: "string",
    userId: this.user.id,
  };
  this.adminService
    .createUserDetails(userDetails)
    .pipe(first())
    .subscribe({
      next: (data: any) => {
        this.loading = false;
        // console.log(data);
        this.messageDialog('Profile Successfully Saved!', 'Your profile details have been updated successfully.', 'success');
      },
      error: (error: any) => {
        console.log(error);
        this.loading = false;
      },
    });
}

logout() {
  this.authService.logout();
  this.router.navigate(["/login"]);
}

getUserById() {
  this.authService.getAppUser().subscribe({
    next: (data: any) => {
      // console.log(data);
      this.authService.updateAppUser(data);
      this.getOrg();
      this.patchProfileForm();
    },
    error: (error: any) => {
      console.error(error.error?.error ?? error);
    },
  });
}

seletedFileName(event: any) {
  console.log(event.value);
  this.selectedField = event.value;
  if (this.selectedField && this.selectedField !== '') {
    this.showDocTypeError = false;
    this.getMediaFiles();
  }
  // else {
  //   this.uploadedFiles = [];
  // }
  // this.triggerFileInput(this.selectedField);
}

viewMyDrive() {
  const myDriveRef = this.matDialog.open(MyDrive, {
    height: "600px",
    width: "700px",
    disableClose: true,
    panelClass: "custom-dialog-container",
    data: {
      entityName: "USER",
      entityId: this.user.id,
    },
  });
  myDriveRef.afterClosed().subscribe((result) => {
    // console.log(result)
  });
}

formatBankAccountNumber(event: any) {
  const input = event.target as HTMLInputElement;
  let value = input.value.replace(/\D/g, ''); // Remove all non-digits

  // Add space after every 4 digits
  let formattedValue = '';
  for (let i = 0; i < value.length; i++) {
    if (i > 0 && i % 4 === 0) {
      formattedValue += ' ';
    }
    formattedValue += value[i];
  }

  // Limit to 20 characters (16 digits + 4 spaces) or whatever is appropriate
  if (formattedValue.length > 24) {
    formattedValue = formattedValue.substring(0, 24);
  }

  this.profileForm.get('bankAccountNumber')?.setValue(formattedValue, { emitEvent: false });
}

  getMediaFiles() {
    // if (!this.selectedField || this.selectedField === '') {
    //   this.uploadedFiles = [];
    //   return;
    // }
    this.userService.getMediaFiles(this.selectedField, this.user.id).subscribe({
      next: (data: any) => {
        this.uploadedFiles = data;
      },
      error: (error: any) => {
        console.log(error);
      }
    });
  }

  viewMediaFile(row: any) {
    console.log(row);
    let viewFileComponent = this.matDialog.open(ViewUploadedFile, {
      disableClose: true,
      height: '800px',
      width: '800px',
      data: row
    });
    viewFileComponent.afterClosed().subscribe(result => {
      console.log(result);
    });
  }

  deleteMedia(id: any) {
    this.loading = true;
    this.userService.deleteMediaById(id).subscribe({
      next: (data: any) => {
        this.loading = false;
        console.log(data);
        this.getMediaFiles();
      },
      error: (error: any) => {
        this.loading = false;
        console.log(error);
      }
    });
  }

  messageDialog(text: any, status: any, type: string) {
    const dialog = this.matDialog.open(SuccessDialog, {
      disableClose: true,
      width: "500px",
      data: {
        title: text,
        subtitle: status,
        icon: type
      },
    });
    dialog.afterClosed().subscribe((result) => { });
  }
}
